import React from 'react';
import styles from 'routes/vendor/storemanage/pages/VendorStoreManage.module.css';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import storeImg from 'routes/vendor/storemanage/images/store_img.png';
import P from 'components/P';
import { useNavigate } from 'react-router-dom';
import VendorStoreListItem from '../components/VendorStoreListItem';

/* 테스트용 매장 리스트 정보 */
const VendorStoreList = [
    {
        storeId: 1,
        storeImg: storeImg,
        storeName: '푸푸 테스트 1호점',
        storeMachine: [true, true],
        storeKiosk: true,
    },
    {
        storeId: 2,
        storeImg: storeImg,
        storeName: '푸푸 테스트 2호점',
        storeMachine: [true, true],
        storeKiosk: false,
    },
    {
        storeId: 3,
        storeImg: storeImg,
        storeName: '푸푸 테스트 3호점',
        storeMachine: [true, false],
        storeKiosk: true,
    },
    {
        storeId: 4,
        storeImg: storeImg,
        storeName: '푸푸 테스트 1호점',
        storeMachine: [true, true],
        storeKiosk: true,
    },
    {
        storeId: 5,
        storeImg: storeImg,
        storeName: '푸푸 테스트 2호점',
        storeMachine: [true, true],
        storeKiosk: false,
    },
    {
        storeId: 6,
        storeImg: storeImg,
        storeName: '푸푸 테스트 3호점',
        storeMachine: [true, false],
        storeKiosk: true,
    },
];

const VendorStoreManage = () => {
    const navigate = useNavigate();

    const handleClickDetail = store => {
        navigate({ pathname: `/vendor/storeDetail/${store.storeId}` });
    };

    return (
        <Container>
            <P
                size="max(1.8vw, 24px)"
                weight={700}
                backgroundColor="white"
                padding="1rem 1rem 0"
            >
                매장 관리
            </P>
            <div className={styles.scroll}>
                <VerticalFlex height="auto">
                    {/* 반복 구간 */}
                    {VendorStoreList.map((store, index) => (
                        <VendorStoreListItem
                            key={index}
                            store={store}
                            onClick={handleClickDetail}
                        />
                    ))}
                    {/* 반복 구간 */}
                </VerticalFlex>
            </div>
        </Container>
    );
};

export default VendorStoreManage;
